import { cn } from '@/lib/utils'

interface HealthItem {
  service: string
  status: 'healthy' | 'warning' | 'critical'
  uptime: string
}

interface HealthGridProps {
  items: HealthItem[]
}

export function HealthGrid({ items }: HealthGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((item) => (
        <div
          key={item.service}
          className="flex items-center justify-between p-4 bg-slate-900/50 border border-slate-800 rounded-lg"
        >
          <div className="flex items-center gap-3">
            <div className="relative flex size-3">
              <span
                className={cn(
                  'animate-ping absolute inline-flex h-full w-full rounded-full opacity-75',
                  item.status === 'healthy' && 'bg-emerald-400',
                  item.status === 'warning' && 'bg-amber-400',
                  item.status === 'critical' && 'bg-rose-400',
                )}
              />
              <span
                className={cn(
                  'relative inline-flex rounded-full size-3',
                  item.status === 'healthy' && 'bg-emerald-500',
                  item.status === 'warning' && 'bg-amber-500',
                  item.status === 'critical' && 'bg-rose-500',
                )}
              />
            </div>
            <span className="text-sm font-medium text-slate-200">{item.service}</span>
          </div>
          <span className="text-xs font-mono text-slate-500">{item.uptime}</span>
        </div>
      ))}
    </div>
  )
}
